export type AlertSeverity = 'INFO' | 'WARNING' | 'CRITICAL';

/**
 * 경보 심각도 색 — 목록 배지·상단 배너·상세 근거 카드가 모두 여기를 본다.
 *
 * 화면마다 색을 따로 두면 같은 경보가 목록에선 빨강, 배너에선 주황으로 보인다.
 * 실제로 그런 상태였다.
 *
 * 일반(WARNING)은 주황 대신 노란 계열을 쓴다. 주황은 빨강과 나란히 놓으면
 * 구분이 잘 안 돼서, 긴급과 일반의 우선순위 차이가 눈에 들어오지 않는다.
 */
export const SEVERITY_COLOR: Record<AlertSeverity, { dot: string; text: string }> = {
  /** 긴급 */
  CRITICAL: { dot: '#D32F2F', text: '#B71C1C' },
  /** 일반 — 노란 계열. 글자는 흰 배경에서 읽히도록 훨씬 어둡게 잡는다 */
  WARNING: { dot: '#F5A800', text: '#8A6100' },
  /** 참고 */
  INFO: { dot: '#0288D1', text: '#01579B' },
};

export function severityColor(severity: string): { dot: string; text: string } {
  return SEVERITY_COLOR[severity as AlertSeverity] ?? SEVERITY_COLOR.INFO;
}

/** 여러 경보 중 가장 높은 심각도 (강조선 색 결정용) */
export function highestSeverity(severities: string[]): AlertSeverity {
  if (severities.includes('CRITICAL')) return 'CRITICAL';
  if (severities.includes('WARNING')) return 'WARNING';
  return 'INFO';
}
